import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
export var ToolbarContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 4px;\n"])));